"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_is_1 = require("react-is");
function flattenChildren(children) {
    const nodes = [];
    children.forEach((child) => {
        if ((0, react_is_1.isFragment)(child)) {
            if (!child.props.children)
                return;
            nodes.push(...flattenChildren(child.props.children));
        }
        else {
            nodes.push(child);
        }
    });
    return nodes;
}
exports.default = flattenChildren;
